import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=684079d9&scoped=true&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684079d9",
  null
  
)

export default component.exports